import { useLocalStorage } from 'usehooks-ts'

import { useQueryClient } from '@tanstack/react-query'

import { LayoutReactQueryKeys } from '@/components/header/types'

import useCartData from './use-cart-data'

import { CartReactQueryKeys } from '../(order)/cart/types'
import { CartViewModel } from '../../types/api'

export const useAppCart = () => {
    const { isLoading, isAuditing, cart: apiCart } = useCartData()
    const [cartInStorage, setCartInStorage] = useLocalStorage<CartViewModel | undefined>('KHNM_CART', apiCart)
    const queryClient = useQueryClient()

    const updateCart = (newCart: CartViewModel) => {
        queryClient.setQueryData([CartReactQueryKeys.MyCart], newCart)
        queryClient.setQueryData([LayoutReactQueryKeys.CartCount], newCart.sumOfQty)

        setCartInStorage(newCart)
    }

    return { cart: apiCart, updateCart, isAuditing, isLoading, cartInStorage }
}
